
export const strongTranslationsUK = {
  "G11": {
    m: "Авраам",
    d: "Патріарх Авраам, батько віруючих.",
    u: "Використовується 73 рази в НЗ. Взірець віри.",
    e: "Від євр. אַבְרָהָם (Авраам) = батько багатьох"
  },
  "G25": {
    m: "любити божественною і безумовною любов'ю",
    d: "Любити безкорисливою, жертовною і божественною любов'ю. Це любов Бога до людства і любов, якою ми повинні любити один одного.",
    u: "Використовується 143 рази в НЗ. Описує божественну, досконалу і безумовну любов.",
    e: "Від ἄγω (аго) = вести, спрямовувати до добра"
  },
  "G26": {
    m: "божественна любов, милосердя",
    d: "Досконала любов Бога; братерська любов, прихильність, добра воля, милосердя. Любов, що поєднує Бога і людину, і людину з ближнім.",
    u: "Використовується 116 разів у НЗ. Центральне слово християнства для опису божественної любові.",
    e: "Походить від ἀγαπάω (агапао)"
  },
  "G27": {
    m: "улюблений, дорогий",
    d: "Коханий, дорогий; улюблений Богом чи людьми.",
    u: "Використовується 61 раз у НЗ. Улюблений Син Божий.",
    e: "Від ἀγαπάω (агапао) = любити"
  },
  "G32": {
    m: "ангел, посланець",
    d: "Посланець; небесний ангел на службі Богу.",
    u: "Використовується 175 разів у НЗ. Ангели Божі.",
    e: "Від ἀγγέλλω (ангелло) = сповіщати"
  },
  "G36": {
    m: "низького походження, неблагородний",
    d: "Без благородства, низького походження; зневажений.",
    u: "Використовується 1 раз у НЗ (1 Кор 1:28).",
    e: "Від ἀ- (заперечення) + γένος (генос) = народження"
  },
  "G93": {
    m: "несправедливість, беззаконня",
    d: "Порушення права, несправедливість; злоба, моральне беззаконня.",
    u: "Використовується 25 разів у НЗ. Протилежність δικαιοσύνη (справедливості).",
    e: "Від ἀ- (заперечення) + δίκη (діке) = справедливість"
  },
  "G154": {
    m: "просити, благати, молити",
    d: "Просити, благати про щось, молити, петиціонувати. Смиренне та шанобливе прохання.",
    u: "Використовується 70 разів у НЗ. Прохання, спрямоване до Бога або людей.",
    e: "Від αἰτέω (айтео) первинний корінь; просити"
  },
  "G166": {
    m: "вічний, безкінечний",
    d: "Без початку і кінця, що існує завжди; в НЗ часто пов'язано з вічним життям у Бозі.",
    u: "Використовується 71 раз у НЗ. Часто визначає вічне життя і Царство Боже.",
    e: "Від αἰών (айон) = вік, епоха, вічність"
  },
  "G225": {
    m: "істина, реальність",
    d: "Те, що істинне в речах, що стосуються Бога і обов'язків людини; явлена божественна істина.",
    u: "Використовується 109 разів у НЗ. Центральне поняття вчення Ісуса.",
    e: "Від ἀληθής (алетес) = істинний, щирий"
  },
  "G281": {
    m: "амінь, істинно",
    d: "Формула підтвердження: хай буде так, істинно, безумовно.",
    u: "Використовується 129 разів у НЗ. Ісус каже 'Істинно, істинно'.",
    e: "Від євр. אָמֵן (амен) = міцний, вірний"
  },
  "G444": {
    m: "людина, людська істота",
    d: "Людська істота, чоловік або жінка; людство взагалі.",
    u: "Використовується 550 разів у НЗ. Людина, створена за образом Божим.",
    e: "Від ἀνήρ (анер) = чоловік та ὤψ (опс) = обличчя"
  },
  "G622": {
    m: "губити, руйнувати, гинути",
    d: "Повністю руйнувати; губити, гинути; бути зруйнованим.",
    u: "Використовується 90 разів у НЗ. Рятувати те, що загинуло.",
    e: "Від ἀπό (апо) = від + ὄλλυμι (оллюмі) = руйнувати"
  },
  "G649": {
    m: "посилати, делегувати",
    d: "Посилати з місією; делегувати як посла.",
    u: "Використовується 132 рази в НЗ. Отець посилає Сина.",
    e: "Від ἀπό (апо) = від + στέλλω (стелло) = посилати"
  },
  "G721": {
    m: "ягня",
    d: "Маленьке ягня; позначає Ісуса Христа як Агнця Божого.",
    u: "Використовується 30 разів у НЗ, особливо в Одкровенні.",
    e: "Зменшувальне від ἀρήν (арен) = ягня"
  },
  "G730": {
    m: "чоловіча стать, чоловік",
    d: "Чоловічої статі, самець.",
    u: "Використовується 9 разів у НЗ. Бог створив людину чоловіком і жінкою.",
    e: "Первинний корінь"
  },
  "G740": {
    m: "хліб",
    d: "Хліб, їжа; хліб життя = Христос.",
    u: "Використовується 97 разів у НЗ. Ісус хліб життя.",
    e: "Від ἄρω (аро) = піднімати, підносити"
  },
  "G746": {
    m: "початок, джерело",
    d: "Початок, походження, перший принцип. У Івана 1:1-2 позначає вічний початок, де вже існувало Слово (Логос).",
    u: "Використовується 55 разів у НЗ. Ключове слово Івана 1:1 'Споконвіку було Слово'.",
    e: "Первинне слово; початок, перше джерело"
  },
  "G772": {
    m: "слабкий, хворий",
    d: "Без сили, слабкий; хворий, немічний; духовно слабкий.",
    u: "Використовується 25 разів у НЗ. Бог обирає слабких світу.",
    e: "Від ἀ- (заперечення) + σθένος (стенос) = сила"
  },
  "G907": {
    m: "хрестити, занурювати",
    d: "Занурювати у воду; хрестити для очищення чи посвячення.",
    u: "Використовується 77 разів у НЗ. Християнське хрещення.",
    e: "Від βάπτω (bapto) = занурювати, вмочувати"
  },
  "G1080": {
    m: "народжувати, давати життя",
    d: "Народжувати, давати народження; народитися знову духовно.",
    u: "Використовується 97 разів у НЗ. Народитися від Бога, народитися знову.",
    e: "Первинний корінь"
  },
  "G1096": {
    m: "ставати, відбуватися, діятися",
    d: "Ставати, приходити до існування, відбуватися, мати місце, виникати.",
    u: "Використовується 678 разів у НЗ. 'Все через Нього почало бути' (Івана 1:3).",
    e: "Від γίνομαι (гіномай) = ставати"
  },
  "G1097": {
    m: "знати, розуміти",
    d: "Знати через особистий досвід; розуміти, сприймати, усвідомлювати.",
    u: "Використовується 222 рази в НЗ. Знання через досвід, а не тільки інтелектуальне.",
    e: "Індоєвропейський корінь *gen- = породжувати, знати"
  },
  "G1100": {
    m: "язик, мова",
    d: "Орган мовлення; мова, діалект; дар мов.",
    u: "Використовується 50 разів у НЗ. Дар мов.",
    e: "Первинний корінь"
  },
  "G1166": {
    m: "показувати, демонструвати",
    d: "Показувати на очах, показувати; доводити, демонструвати.",
    u: "Використовується 33 рази в НЗ. Бог показує свою славу.",
    e: "Первинний корінь"
  },
  "G1208": {
    m: "другий, другорядний",
    d: "Другий у ряду чи порядку.",
    u: "Використовується 44 рази в НЗ. Друга заповідь.",
    e: "Від δύο (дюо) = два"
  },
  "G1271": {
    m: "розум, мислення",
    d: "Здатність думати, чути, розуміти; розум, розуміння.",
    u: "Використовується 12 разів у НЗ. Розум, оновлений Христом.",
    e: "Від διά (діа) = через + νοῦς (ноус) = розум"
  },
  "G1320": {
    m: "вчитель, наставник, учитель",
    d: "Вчитель, наставник; той, хто навчає релігійних істин.",
    u: "Використовується 59 разів у НЗ. 'Равві, ми знаємо, що Ти вчитель, який прийшов від Бога' (Івана 3:2).",
    e: "Від διδάσκω (дідаско) = навчати"
  },
  "G1325": {
    m: "давати, дарувати",
    d: "Давати щось комусь; дарувати, дозволяти; віддавати.",
    u: "Використовується 415 разів у НЗ. Бог дає щедро.",
    e: "Первинний корінь"
  },
  "G1372": {
    m: "відчувати спрагу, прагнути",
    d: "Страждати від спраги; палко бажати, прагнути.",
    u: "Використовується 16 разів у НЗ. Духовна спрага до Бога.",
    e: "Від δίψα (діпса) = спрага"
  },
  "G1401": {
    m: "раб, слуга",
    d: "Раб, слуга; добровільний слуга Божий.",
    u: "Використовується 124 рази в НЗ. Слуги Христа.",
    e: "Від δέω (део) = зв'язувати"
  },
  "G1411": {
    m: "сила, могутність, чудо",
    d: "Сила, потужність, здатність; акт могутності, чудо.",
    u: "Використовується 120 разів у НЗ. Сила Бога, Святого Духа.",
    e: "Від δύναμαι (дюнамай) = бути здатним"
  },
  "G1417": {
    m: "два",
    d: "Число два; пара.",
    u: "Використовується 135 разів у НЗ. Два чи три свідки.",
    e: "Первинний корінь"
  },
  "G1473": {
    m: "я, мене",
    d: "Особовий займенник першої особи однини.",
    u: "Використовується 2567 разів у НЗ. Дуже частий.",
    e: "Первинний займенник"
  },
  "G1484": {
    m: "народ, люди, язичники",
    d: "Народ, нація; язичницькі народи (неєвреї).",
    u: "Використовується 162 рази в НЗ. Євангеліє для всіх народів.",
    e: "Первинний корінь"
  },
  "G1492": {
    m: "знати, бачити, розуміти",
    d: "Знати через сприйняття, бачити, розуміти, усвідомлювати. Знання, отримане через досвід або одкровення.",
    u: "Використовується 666 разів у НЗ. Основне дієслово знання в Євангелії від Івана.",
    e: "Досконала форма εἴδω (ейдо); бачити, знати"
  },
  "G1510": {
    m: "бути, існувати",
    d: "Дієслово бути в усіх його значеннях; існувати, залишатися, відбуватися.",
    u: "Найбільш вживане дієслово в НЗ (2460+ разів).",
    e: "Первинний корінь"
  },
  "G1515": {
    m: "мир",
    d: "Стан спокою; мир з Богом; гармонія між людьми.",
    u: "Використовується 92 рази в НЗ. Мир Христа.",
    e: "Від εἴρω (ейро) = з'єднувати, зв'язувати"
  },
  "G1520": {
    m: "один, єдиний",
    d: "Тільки один; єдиний, лише; якийсь.",
    u: "Використовується 344 рази в НЗ. Єдність Бога, об'єднана церква.",
    e: "Первинний корінь"
  },
  "G1586": {
    m: "вибирати, обирати",
    d: "Вибирати для себе, відбирати; обирати божественною благодаттю.",
    u: "Використовується 21 раз у НЗ. Бог обирає своїх дітей.",
    e: "Від ἐκ (ек) = з + λέγω (лего) = вибирати"
  },
  "G1658": {
    m: "вільний, звільнений",
    d: "Вільний, не раб; звільнений від рабства гріха.",
    u: "Використовується 23 рази в НЗ. Звільнені в Христі.",
    e: "Ймовірно від ἔρχομαι (ерхомай) = приходити"
  },
  "G1672": {
    m: "грек, язичник",
    d: "Грек за народженням чи мовою; не іудей.",
    u: "Використовується 25 разів у НЗ. Ані іудея, ані грека в Христі.",
    e: "Від Ἑλλάς (Геллас) = Греція"
  },
  "G1680": {
    m: "надія, впевнене очікування",
    d: "Очікування добрих речей, надія, заснована на Бозі; впевненість у майбутньому, заснована на божественних обітницях.",
    u: "Використовується 54 рази в НЗ. Одна з трьох богословських чеснот разом з вірою і любов'ю.",
    e: "Від ἔλπω (ельпо) = чекати, сподіватися"
  },
  "G1743": {
    m: "зміцнювати, робити сильним",
    d: "Робити сильним, зміцнювати; давати силу.",
    u: "Використовується 8 разів у НЗ. Бог зміцнює віруючих.",
    e: "Від ἐν (ен) = в + δυναμόω (динамоо) = робити могутнім"
  },
  "G1746": {
    m: "одягати, вбиратися",
    d: "Одягати одяг; вбиратися в якість чи силу.",
    u: "Використовується 27 разів у НЗ. Вбратися в Христа, вбратися в обладунок Божий.",
    e: "Від ἐν (ен) = в + δύω (дюо) = входити, вбиратися"
  },
  "G1785": {
    m: "заповідь, наказ",
    d: "Наказ, заповідь, правило; особливо божественна заповідь.",
    u: "Використовується 67 разів у НЗ. Заповіді Бога і Христа.",
    e: "Від ἐντέλλομαι (ентелломай) = наказувати"
  },
  "G1848": {
    m: "зневажати, ставитися зі зневагою",
    d: "Вважати нічим, зневажати; ставитися з презирством.",
    u: "Використовується 11 разів у НЗ. Світ зневажає те, що обирає Бог.",
    e: "Від ἐξ (екс) = з + οὐθείς (утейс) = ніхто"
  },
  "G2041": {
    m: "справа, праця, діяння",
    d: "Робота, праця; дія, вчинок; виконана справа.",
    u: "Використовується 169 разів у НЗ. Справи Божі, добрі справи.",
    e: "Від ἔργω (ерго) = працювати"
  },
  "G2048": {
    m: "пустеля, безлюдний",
    d: "Пустельне місце, пустеля; самотній, безлюдний.",
    u: "Використовується 48 разів у НЗ. 40 днів Ісуса в пустелі.",
    e: "Від ἔρημος (еремос) = покинутий"
  },
  "G2065": {
    m: "питати, допитувати, розпитувати",
    d: "Питати, допитувати, розпитувати для отримання інформації. Дослідження або розслідування.",
    u: "Використовується 63 рази у НЗ. Питання для отримання відповідей.",
    e: "Невизначений корінь; питати, допитувати"
  },
  "G2189": {
    m: "ворожнеча, ворожість",
    d: "Ненависть, ворожість, ворожнеча.",
    u: "Використовується 6 разів у НЗ. Ворожнеча з Богом скасована.",
    e: "Від ἐχθρός (ехтрос) = ворог"
  },
  "G2205": {
    m: "ревність, заздрість, зависть",
    d: "Пристрасний запал; може бути позитивним (ревність до Бога) або негативним (заздрість, зависть).",
    u: "Використовується 16 разів у НЗ. Може бути чеснотою чи пороком залежно від контексту.",
    e: "Від ζέω (дзео) = кипіти, бути палким"
  },
  "G2222": {
    m: "життя",
    d: "Фізичне чи духовне життя; вічне життя в Бозі.",
    u: "Використовується 135 разів у НЗ. Ісус є життя.",
    e: "Від ζάω (дзао) = жити"
  },
  "G2258": {
    m: "був, він був",
    d: "Був, він був, вона була. Форма минулого часу дієслова бути (εἰμί). Виражає стан або існування в минулому.",
    u: "Використовується 267 разів у НЗ. Ключове слово в Івана 1:1 'Споконвіку було Слово'.",
    e: "Минулий час від εἰμί (еймі) = бути; був"
  },
  "G2296": {
    m: "дивуватися, здивуватися, захоплюватися",
    d: "Дивуватися, здивуватися, бути враженим, захоплюватися. Реакція здивування на щось надзвичайне.",
    u: "Використовується 43 рази у НЗ. Частая реакція на чудеса та вчення Ісуса.",
    e: "Від θαῦμα (тавма) = диво; дивуватися"
  },
  "G2316": {
    m: "Бог, божество",
    d: "Єдиний істинний Бог, Всевишня та вічна Істота. У Новому Заповіті означає Бога Отця, або Ісуса Христа Сина, або Святого Духа - Святу Трійцю.",
    u: "Використовується 1343 рази у НЗ. Основне слово для позначення єдиного істинного Бога в єдності Трійці.",
    e: "Невизначена спорідненість згідно зі Стронгом. Позначає божество, особливо найвищу Божественність. Біблійне вживання: відкриває живого Бога, що діє в історії спасіння."
  },
  "G2338": {
    m: "жіноча стать, жінка",
    d: "Жіночої статі, самка.",
    u: "Використовується 5 разів у НЗ. Чоловік і жінка рівні в Христі.",
    e: "Від θηλάζω (теладзо) = годувати груддю"
  },
  "G2362": {
    m: "престол",
    d: "Королівське сидіння, престол; влада і царська могутність.",
    u: "Використовується 62 рази в НЗ. Престол Бога і Агнця.",
    e: "Первинний корінь"
  },
  "G2381": {
    m: "Хома",
    d: "Хома, власне ім'я. Один з дванадцяти апостолів, також званий Дідим (близнюк). Відомий вимогою доказів воскресіння.",
    u: "Використовується 11 разів у НЗ. Апостол, який сумнівався, а потім повірив.",
    e: "З арамейського תְּאוֹמָא (теома) = близнюк"
  },
  "G2398": {
    m: "власний, особливий, персональний",
    d: "Власний, особливий, персональний, приватний. Те, що належить власне комусь, відмінне від інших.",
    u: "Використовується 114 разів у НЗ. Поняття особистої власності та відмінності.",
    e: "Від невизначеного кореня; власний, особливий"
  },
  "G2424": {
    m: "Ісус",
    d: "Ісус з Назарета, Месія, Спаситель.",
    u: "Використовується 917 разів у НЗ. Ім'я понад усяке ім'я.",
    e: "Від євр. יְהוֹשֻׁעַ (Ягошуа) = ЯГВЕ спасає"
  },
  "G2453": {
    m: "іудей, юдей",
    d: "Належить до іудейської раси; житель Юдеї.",
    u: "Використовується 195 разів у НЗ. Іудеї, обраний народ Божий.",
    e: "Від Ἰούδας (Іудас) = Юда"
  },
  "G2491": {
    m: "Іван",
    d: "Іван, власне ім'я. Іван Хреститель попередник, Іван улюблений апостол, автор Євангелія та послань.",
    u: "Використовується 135 разів у НЗ. Ім'я двох великих постатей НЗ.",
    e: "З єврейського יוֹחָנָן (Йоханан) = YHWH милостивий"
  },
  "G2531": {
    m: "як, згідно з",
    d: "Як, таким же чином; згідно з, настільки, наскільки.",
    u: "Використовується 182 рази в НЗ. Порівняльний сполучник.",
    e: "Від κατά (ката) = згідно з + ὡς (гос) = як"
  },
  "G2537": {
    m: "новий, свіжий",
    d: "Новий у часі чи якості; свіжий, недавній, не вживаний.",
    u: "Використовується 42 рази в НЗ. Нове створіння, нова заповідь.",
    e: "Корінь невизначений"
  },
  "G2570": {
    m: "добрий, гарний",
    d: "Добрий за своєю природою, гарний; шанований, відмінний, чеснотний.",
    u: "Використовується 100 разів у НЗ. Добрий пастир, добрі вчинки.",
    e: "Первинний корінь"
  },
  "G2588": {
    m: "серце",
    d: "Фізичне серце; центр внутрішнього життя, душа, дух; думки і почуття.",
    u: "Використовується 156 разів у НЗ. Осідок духовного життя.",
    e: "Первинний корінь"
  },
  "G2596": {
    m: "згідно з, проти, через",
    d: "Прийменник з кількома значеннями: згідно з, відповідно до; проти; через.",
    u: "Використовується понад 470 разів у НЗ. Дуже частий прийменник.",
    e: "Первинний прийменник"
  },
  "G2617": {
    m: "соромити, ганьбити",
    d: "Соромити, ганьбити; бентежити, принижувати.",
    u: "Використовується 13 разів у НЗ. Бог бентежить мудрих світу.",
    e: "Від κατά (ката) = проти + αἰσχύνω (айсхюно) = соромитися"
  },
  "G2744": {
    m: "хвалитися, величатися",
    d: "Хвалитися, величатися; знаходити свою гордість у чомусь.",
    u: "Використовується 37 разів у НЗ. Хвалитися в Господі.",
    e: "Від καῦχος (каухос) = хвастощі"
  },
  "G2889": {
    m: "світ, всесвіт, людство",
    d: "Світовий порядок, всесвіт; падле людство; система, що протистоїть Богу.",
    u: "Використовується 186 разів у НЗ. Може означати творіння або гріховну систему.",
    e: "Від κοσμέω (космео) = прикрашати, упорядковувати"
  },
  "G2919": {
    m: "судити, вирішувати",
    d: "Судити, виносити суд; вирішувати, визначати.",
    u: "Використовується 114 разів у НЗ. Бог судить світ.",
    e: "Первинний корінь"
  },
  "G2920": {
    m: "суд, справедливість, засудження",
    d: "Суд, справедливість, засудження, судове рішення. Суд Божий, справедливий і досконалий.",
    u: "Використовується 47 разів у НЗ. Центральне поняття божественної справедливості.",
    e: "Від κρίνω (крино) = судити, вирішувати"
  },
  "G2962": {
    m: "Господь, Владика, власник",
    d: "Господь, Владика; титул поваги і божественної влади; Ісус як Господь.",
    u: "Використовується 748 разів у НЗ. 'Хома сказав Йому: Господи, ми не знаємо, куди Ти йдеш' (Івана 14:5).",
    e: "Від κύριος (куріос) = мати владу"
  },
  "G2992": {
    m: "народ",
    d: "Народ, нація; особливо Божий народ (Ізраїль або Церква).",
    u: "Використовується 142 рази в НЗ. Обраний народ Божий.",
    e: "Первинний корінь"
  },
  "G3022": {
    m: "білий, яскравий",
    d: "Білий, сяючий; символ чистоти і перемоги.",
    u: "Використовується 25 разів у НЗ. Білі одежі викуплених.",
    e: "Від λευκός (леукос) = білий, світлий"
  },
  "G3056": {
    m: "слово, мова, розум",
    d: "Вимовлене слово; розум, інтелект; Логос = Христос.",
    u: "Використовується 330 разів у НЗ. Втілений Логос.",
    e: "Від λέγω (лего) = говорити"
  },
  "G3101": {
    m: "учень, студент",
    d: "Той, хто вчиться, студент, учень; послідовник Ісуса.",
    u: "Використовується 261 раз у НЗ. Позначає послідовників Христа.",
    e: "Від μανθάνω (мантано) = вчитися"
  },
  "G3141": {
    m: "свідчення, засвідчення",
    d: "Свідчення, засвідчення, доказ, підтвердження. Свідчення про істину, особливо про Христа.",
    u: "Використовується 37 разів у НЗ. Головна тема Євангелія від Івана.",
    e: "Від μάρτυς (мартис) = свідок"
  },
  "G3173": {
    m: "великий, важливий",
    d: "Великий за розміром, кількістю або важливістю; могутній, дивовижний.",
    u: "Використовується 243 рази в НЗ. Величність Бога.",
    e: "Первинний корінь"
  },
  "G3320": {
    m: "розділова стіна",
    d: "Середня стіна, перегородка поділу.",
    u: "Використовується 1 раз у НЗ (Еф 2:14). Стіна між іудеями і язичниками.",
    e: "Від μέσος (месос) = середина + τοῖχος (тойхос) = стіна"
  },
  "G3439": {
    m: "єдинонароджений, єдиний",
    d: "Унікальний у своєму роді, єдинонароджений; єдиний син.",
    u: "Використовується 9 разів у НЗ. Єдинонароджений Син Божий.",
    e: "Від μόνος (монос) = сам + γίνομαι (гіномай) = ставати"
  },
  "G3474": {
    m: "безумство, дурість",
    d: "Безумство, абсурдність; те, що позбавлене мудрості.",
    u: "Використовується 5 разів у НЗ. Мудрість Божа здається безумством світові.",
    e: "Від μωρός (морос) = божевільний, нерозумний"
  },
  "G3475": {
    m: "Мойсей",
    d: "Мойсей, законодавець Ізраїлю.",
    u: "Використовується 80 разів у НЗ. Закон Мойсея.",
    e: "Від євр. מֹשֶׁה (Моше) = витягнутий (з води)"
  },
  "G3530": {
    m: "Никодім",
    d: "Никодім, власне ім'я. Фарисей та єврейський керівник, що приходив до Ісуса вночі. Грецьке ім'я, що означає 'перемога народу'.",
    u: "Використовується 5 разів у НЗ. Важлива постать в Євангелії від Івана.",
    e: "З грецького νίκη (ніке) = перемога та δῆμος (демос) = народ"
  },
  "G3551": {
    m: "закон, Тора",
    d: "Закон, Тора, правило, принцип. Закон Мойсея, божественний закон, заповіді Божі.",
    u: "Використовується 194 рази у НЗ. Центральне поняття божественного одкровення.",
    e: "Від νέμω (немо) = розподіляти, давати; даний закон"
  },
  "G3571": {
    m: "ніч",
    d: "Ніч, період темряви між заходом і сходом сонця. Часто метафора духовного невігластва.",
    u: "Використовується 61 раз у НЗ. Протиставляється світлу в іванівській символіці.",
    e: "Первинний жіночий іменник; ніч"
  },
  "G3598": {
    m: "шлях, дорога",
    d: "Дорога, шлях; спосіб життя, поведінка; шлях спасіння.",
    u: "Використовується 101 раз у НЗ. Ісус є шлях.",
    e: "Первинний корінь"
  },
  "G3609": {
    m: "домашній, сімейний",
    d: "Належить до дому, член родини; домашній слуга.",
    u: "Використовується 3 рази в НЗ. Описує членів Божої родини.",
    e: "Від οἶκος (ойкос) = дім"
  },
  "G3664": {
    m: "подібний, схожий",
    d: "Подібний, тієї ж природи чи характеру; еквівалентний.",
    u: "Використовується 45 разів у НЗ. Друга заповідь подібна до першої.",
    e: "Від ὁμός (гомос) = той самий"
  },
  "G3686": {
    m: "ім'я",
    d: "Ім'я, титул; репутація; влада, сила.",
    u: "Використовується 228 разів у НЗ. Ім'я Ісуса.",
    e: "Первинний корінь"
  },
  "G3708": {
    m: "бачити, дивитися",
    d: "Бачити очима; сприймати, розуміти; з'являтися.",
    u: "Використовується 454 рази в НЗ. Бачити Христа, бачити Отця.",
    e: "Первинний корінь"
  },
  "G3735": {
    m: "гора, пагорб",
    d: "Гора, гора; високий пагорб.",
    u: "Використовується 63 рази в НЗ. Гора Преображення.",
    e: "Ймовірно від ὁράω (гораó) = бачити"
  },
  "G3756": {
    m: "не, ні",
    d: "Абсолютне заперечення, ні, не.",
    u: "Використовується понад 1600 разів у НЗ. Дуже частий заперечний службовий член.",
    e: "Первинний заперечний службовий член"
  },
  "G3762": {
    m: "ніхто, нічого, жодний",
    d: "Ніхто, нічого, жодний, навіть один. Абсолютне заперечення існування або кількості.",
    u: "Використовується 234 рази у НЗ. Дуже поширене сильне заперечення.",
    e: "Від οὐδέ (уде) та εἷς (хейс); навіть не один"
  },
  "G3778": {
    m: "цей, ця, це",
    d: "Вказівний займенник: цей, ця, це. Позначає щось близьке або раніше згадане.",
    u: "Використовується 1388 разів у НЗ. Найчастіший вказівний займенник.",
    e: "Первинний вказівний займенник"
  },
  "G3789": {
    m: "змія",
    d: "Змія, плазун; стародавній змій (Сатана).",
    u: "Використовується 14 разів у НЗ. Мідний змій у пустелі.",
    e: "Первинний корінь"
  },
  "G3793": {
    m: "натовп, множина",
    d: "Натовп людей, множина; народна маса.",
    u: "Використовується 175 разів у НЗ. Натовпи, що йшли за Ісусом.",
    e: "Від ὄχος (охос) = транспортний засіб (що несе)"
  },
  "G3880": {
    m: "отримувати, брати, приймати",
    d: "Отримувати, брати, приймати, хапати. Отримувати щось, що пропонується або дається.",
    u: "Використовується 59 разів у НЗ. Центральне поняття прийняття Євангелія.",
    e: "Від παρά (пара) = поруч та λαμβάνω (ламбано) = брати"
  },
  "G3956": {
    m: "весь, кожен",
    d: "Весь, кожен, всі; повнота, сукупність.",
    u: "Використовується 1244 рази в НЗ. Серед найчастіших слів.",
    e: "Первинний корінь"
  },
  "G3962": {
    m: "батько",
    d: "Природний чи духовний батько; предок; Бог Отець.",
    u: "Використовується 413 разів у НЗ. Часто для позначення Бога.",
    e: "Первинний корінь, споріднений з латинським 'pater'"
  },
  "G4100": {
    m: "вірити, мати віру",
    d: "Мати віру в, вірити; довіряти, покладатися на.",
    u: "Використовується 241 раз у НЗ. Вірити в Ісуса, щоб бути спасенним.",
    e: "Від πίστις (пістіс) = віра"
  },
  "G4102": {
    m: "віра, довіра, вірність",
    d: "Переконання в істині чого-небудь, віра; в НЗ переконання щодо відносин людини з Богом і божественними речами.",
    u: "Використовується 244 рази в НЗ. Центральне поняття христової віри.",
    e: "Від πείθω (пейто) = переконувати, умовляти"
  },
  "G4138": {
    m: "повнота, достаток, що наповнює",
    d: "Повнота, достаток, що повністю наповнює. Цілісність, божественна повнота.",
    u: "Використовується 17 разів у НЗ. Богословське поняття божественної повноти у Христі.",
    e: "Від πλήρης (плерес) = повний; повнота"
  },
  "G4139": {
    m: "ближній, сусід",
    d: "Той, хто поблизу, сусід; ближній взагалі.",
    u: "Використовується 17 разів у НЗ. 'Люби ближнього свого як самого себе'.",
    e: "Прислівник став іменником, від πλησίος (плесіос) = близько"
  },
  "G4151": {
    m: "дух, подих, вітер",
    d: "Подих життя, життєвий принцип; розумна душа; Святий Дух.",
    u: "Використовується 385 разів у НЗ. Позначає Святого Духа, людський дух або духів.",
    e: "Від πνέω (пнео) = дути, дихати"
  },
  "G4160": {
    m: "робити, творити, здійснювати", 
    d: "Робити, творити, виробляти, діяти, створювати. Загальне дієслово дії, що охоплює всі види діяльності.",
    u: "Використовується 568 разів у НЗ. Основне дієслово дії, часто у справах Божих.",
    e: "Первинне дієслово; робити, здійснювати"
  },
  "G4166": {
    m: "пастир, пастор",
    d: "Той, хто пасе овець; духовний опікун, церковний пастор.",
    u: "Використовується 18 разів у НЗ. Ісус добрий пастир.",
    e: "Від ποίμνη (поймне) = стадо"
  },
  "G4183": {
    m: "багато, численні, великий",
    d: "Багато, численні, великий за кількістю або числом. Натовп, велика кількість.",
    u: "Використовується 416 разів у НЗ. Дуже частий кількісний прикметник.",
    e: "Невизначений корінь; багато, численні"
  },
  "G4198": {
    m: "йти, ходити, подорожувати",
    d: "Йти, ходити, подорожувати, рухатися. Рух з одного місця до іншого, часто з метою.",
    u: "Використовується 154 рази у НЗ. Основне дієслово руху в євангельських розповідях.",
    e: "Первинне дієслово; йти, ходити"
  },
  "G4238": {
    m: "робити, практикувати, здійснювати",
    d: "Робити, практикувати, здійснювати, діяти. Виконувати дії, часто з ідеєю повторення або звички.",
    u: "Використовується 39 разів у НЗ. Часто пов'язано з практикою добра або зла.",
    e: "Посилена форма від πράω (прао); робити, практикувати"
  },
  "G4263": {
    m: "вівця, баран",
    d: "Вівця або баран; метафорично, учні Христа.",
    u: "Використовується 39 разів у НЗ. Віруючі як вівці пастиря.",
    e: "Ймовірно пов'язано з προβαίνω (пробайно) = просуватися"
  },
  "G4413": {
    m: "перший, головний",
    d: "Перший у часі, місці, порядку або важливості.",
    u: "Використовується 155 разів у НЗ. Перша заповідь, перше місце.",
    e: "Найвищий ступінь від πρό (про) = перед"
  },
  "G4561": {
    m: "плоть, тіло",
    d: "Плоть, м'ясо; людське тіло; падла людська природа.",
    u: "Використовується 147 разів у НЗ. Контраст між плоттю і духом.",
    e: "Первинний корінь"
  },
  "G4592": {
    m: "знак, чудо, знамення",
    d: "Знак, чудо, знамення; надприродний прояв, що відкриває божественну силу.",
    u: "Використовується 77 разів у НЗ. 'бо ніхто не може творити таких знамень, які Ти робиш' (Івана 3:2).",
    e: "Від σημεῖον (семейон) = знак, позначка"
  },
  "G4648": {
    m: "дивитися уважно, цілитися",
    d: "Зосередити очі на, розглядати уважно; мати на увазі, прагнути до мети.",
    u: "Використовується 6 разів у НЗ. Заклик зосередити очі на Христі.",
    e: "Пов'язано з σκοπός (скопос) = ціль, мета"
  },
  "G4680": {
    m: "мудрий, освічений",
    d: "Мудрий, розумний, вмілий; освічений, навчений.",
    u: "Використовується 22 рази в НЗ. Справжня мудрість походить від Бога.",
    e: "Первинний корінь"
  },
  "G4982": {
    m: "рятувати, визволяти",
    d: "Рятувати від небезпеки чи загибелі; визволяти від гріха.",
    u: "Використовується 106 разів у НЗ. Ісус рятує грішників.",
    e: "Від σῶς (сос) = цілий і неушкоджений"
  },
  "G5040": {
    m: "мала дитина",
    d: "Маленька дитина, немовля; ніжне звертання до учня.",
    u: "Використовується 8 разів у НЗ. Іван називає читачів 'маленькі діти'.",
    e: "Зменшувальне від τέκνον (текнон) = дитина"
  },
  "G5087": {
    m: "класти, ставити, встановлювати",
    d: "Класти, ставити; встановлювати, призначати; покладати, ставити.",
    u: "Використовується 100 разів у НЗ. Покласти своє життя за овець.",
    e: "Первинний корінь"
  },
  "G5109": {
    m: "стіна",
    d: "Розділова стіна, перегородка.",
    u: "Використовується 1 раз у НЗ (Дії 23:3).",
    e: "Первинний корінь"
  },
  "G5207": {
    m: "син",
    d: "Нащадок чоловічої статі; учень; член групи. Син Божий = Ісус Христос.",
    u: "Використовується 377 разів у НЗ. Часто для позначення Ісуса як Сина Божого.",
    e: "Походження невизначене, можливо пов'язано з ὕω (гуо) = давати дощ, породжувати"
  },
  "G5281": {
    m: "терпіння, витривалість, наполегливість",
    d: "Якість того, хто не піддається обставинам чи тиску; терпляча витривалість, постійність.",
    u: "Використовується 32 рази в НЗ. Суттєва християнська чеснота.",
    e: "Від ὑπό (гіпо) = під та μένω (мено) = залишатися"
  },
  "G5312": {
    m: "піднімати, возвеличувати",
    d: "Піднімати вгору, підносити; возвеличувати, шанувати.",
    u: "Використовується 20 разів у НЗ. Син Людський піднятий.",
    e: "Від ὕψος (гіпсос) = висота"
  },
  "G5376": {
    m: "Пилип",
    d: "Пилип, власне ім'я. Один з дванадцяти апостолів. Грецьке ім'я, що означає 'любитель коней'.",
    u: "Використовується 36 разів у НЗ. Ім'я апостола та диякона.",
    e: "З грецького φίλος (філос) = друг та ἵππος (гіппос) = кінь"
  },
  "G5432": {
    m: "охороняти, захищати",
    d: "Охороняти військовою вартою; захищати, зберігати.",
    u: "Використовується 4 рази в НЗ. Мир Божий охороняє наші серця.",
    e: "Від φρουρός (фрурос) = вартовий, сторож"
  },
  "G5443": {
    m: "плем'я, рід",
    d: "Плем'я, клан; народ, що походить від спільного предка.",
    u: "Використовується 31 раз у НЗ. Дванадцять племен Ізраїлю.",
    e: "Від φύω (фюо) = виробляти, вирощувати"
  },
  "G5457": {
    m: "світло",
    d: "Фізичне чи духовне світло; явлена божественна істина.",
    u: "Використовується 73 рази в НЗ. Ісус світло світу.",
    e: "Від φάω (фао) = світити"
  },
  "G5463": {
    m: "радіти, бути радісним",
    d: "Радіти, бути щасливим; привітання 'радій' або 'вітаю'.",
    u: "Використовується 74 рази в НЗ. Часта заповідь радіти в Христі.",
    e: "Споріднено з χάρις (харіс) = благодать"
  },
  "G5495": {
    m: "рука",
    d: "Рука; влада, могутність; дія, справа.",
    u: "Використовується 177 разів у НЗ. Рука Божа, руки Ісуса.",
    e: "Первинний корінь"
  },
  "G5544": {
    m: "доброта, благість",
    d: "Доброта в дії, практична благість; якість того, хто корисний, вигідний для інших.",
    u: "Використовується 10 разів у НЗ. Плід Духа згідно з Галатів 5:22.",
    e: "Від χρηστός (хрестос) = добрий, корисний, доброзичливий"
  },
  "G5547": {
    m: "Христос, Месія, Помазаник",
    d: "Помазаник, Месія; титул Ісуса як обіцяного Спасителя.",
    u: "Використовується 529 разів у НЗ. Ісус є Христос.",
    e: "Від χρίω (хріо) = помазувати"
  },
  "G5590": {
    m: "душа, життя",
    d: "Подих життя, життєва душа; саме життя; безсмертна душа.",
    u: "Використовується 105 разів у НЗ. Духовне і вічне життя.",
    e: "Від ψύχω (псюхо) = дихати, освіжати"
  },
  "H120": {
    m: "людина, людство, Адам",
    d: "Людина, людська істота; людство; Адам перша людина.",
    u: "Використовується 562 рази в СЗ. Бог створив людину.",
    e: "Від אָדֹם (адом) = червоний, або אֲדָמָה (адама) = земля"
  },
  "H160": {
    m: "любов, прихильність",
    d: "Любов, прихильність; акт любові.",
    u: "Використовується 40 разів у СЗ. Любов Бога до свого народу.",
    e: "Від אָהַב (агаб) = любити"
  },
  "H216": {
    m: "світло",
    d: "Природне чи духовне світло; щастя, благополуччя.",
    u: "Використовується 120 разів у СЗ. 'Нехай буде світло !'",
    e: "Від אוֹר (ор) = бути світлим"
  },
  "H430": {
    m: "Бог, боги",
    d: "Всевишній Бог (Елогім); іноді використовується для суддів чи язичницьких богів.",
    u: "Використовується 2606 разів у СЗ. Множинне ім'я величі для Бога.",
    e: "Множина від אֱלוֹהַּ (елоах) = бог"
  },
  "H559": {
    m: "казати, говорити",
    d: "Казати, говорити, оголошувати; наказувати, думати.",
    u: "Використовується 5316 разів у СЗ. Найчастіше дієслово мовлення.",
    e: "Первинний корінь"
  },
  "H776": {
    m: "земля, країна",
    d: "Земля, ґрунт; країна, регіон; земний світ.",
    u: "Використовується 2504 рази в СЗ. Земля, яку створив Бог.",
    e: "Первинний корінь"
  },
  "H982": {
    m: "довіряти, мати довіру",
    d: "Довіряти, мати довіру; бути в безпеці.",
    u: "Використовується 120 разів у СЗ. Довіра до Господа.",
    e: "Первинний корінь"
  },
  "H1004": {
    m: "дім, оселя",
    d: "Дім, житло; родина, домочадці; храм.",
    u: "Використовується 2055 разів у СЗ. Дім Господній.",
    e: "Від בָּנָה (бана) = будувати"
  },
  "H1254": {
    m: "творити",
    d: "Творити з нічого; формувати, робити; виключна діяльність Бога.",
    u: "Використовується 54 рази в СЗ. Бог створив небеса і землю.",
    e: "Первинний корінь"
  },
  "H1516": {
    m: "долина, яр",
    d: "Долина, ущелина, яр; рівнина.",
    u: "Використовується 60 разів у СЗ. Долина тіні смерті.",
    e: "Первинний корінь"
  },
  "H1878": {
    m: "годувати, робити товстим",
    d: "Робити товстим, годувати; процвітати.",
    u: "Використовується 11 разів у СЗ. Ти помазуєш мою голову оливою.",
    e: "Від דֶּשֶׁן (дешен) = жир, попіл"
  },
  "H1980": {
    m: "ходити, йти",
    d: "Ходити, йти, приходити; жити, поводитися.",
    u: "Використовується 1554 рази в СЗ. Дуже часте дієслово руху.",
    e: "Первинний корінь"
  },
  "H2617": {
    m: "доброта, милосердя, вірність",
    d: "Доброта, милосердя; вірність завіту; вірна любов.",
    u: "Використовується 248 разів у СЗ. Доброта Господа.",
    e: "Від חָסַד (хасад) = бути добрим, милосердним"
  },
  "H2637": {
    m: "бракувати, потребувати",
    d: "Бракувати, потребувати; зменшуватися, недоставати.",
    u: "Використовується 23 рази в СЗ. Нічого не бракує мені (Пс 23:1).",
    e: "Первинний корінь"
  },
  "H2896": {
    m: "добрий, гарний",
    d: "Добрий, приємний, відмінний; доброзичливий, справедливий.",
    u: "Використовується 559 разів у СЗ. Бог побачив, що це добре.",
    e: "Первинний корінь"
  },
  "H3068": {
    m: "ЯГВЕ, Господь",
    d: "Власне ім'я Бога, священний тетраграм ЯГВЕ.",
    u: "Використовується 6828 разів у СЗ. Найсвятіше ім'я.",
    e: "Від הָיָה (гая) = бути, існувати"
  },
  "H3117": {
    m: "день",
    d: "День (протилежність ночі); період 24 години; епоха, час.",
    u: "Використовується 2301 раз у СЗ. День, який створив Господь.",
    e: "Від יוֹם (йом) = бути теплим"
  },
  "H3372": {
    m: "боятися, страшитися, шанувати",
    d: "Боятися, страшитися; шанувати, поважати Бога.",
    u: "Використовується 335 разів у СЗ. Я не боюся жодного зла.",
    e: "Первинний корінь"
  },
  "H3563": {
    m: "чаша, келих",
    d: "Чаша, келих; частка, доля.",
    u: "Використовується 31 раз у СЗ. Моя чаша переповнюється.",
    e: "Первинний корінь"
  },
  "H3820": {
    m: "серце, дух",
    d: "Серце, осідок емоцій; дух, розум, воля.",
    u: "Використовується 598 разів у СЗ. Серце людини.",
    e: "Первинний корінь"
  },
  "H3915": {
    m: "ніч",
    d: "Ніч (протилежність дню); час темряви.",
    u: "Використовується 234 рази в СЗ. Бог відокремив день і ніч.",
    e: "Первинний корінь"
  },
  "H3966": {
    m: "дуже, вкрай",
    d: "Дуже, вкрай, багато; з силою, швидко.",
    u: "Використовується 300 разів у СЗ. Це було дуже добре.",
    e: "Від מָאַד (маад) = бути численним"
  },
  "H4325": {
    m: "вода, води",
    d: "Вода, води; дощ; потік, море.",
    u: "Використовується 585 разів у СЗ. Води творіння.",
    e: "Двоїна від מַיִם (майім) = вода"
  },
  "H4999": {
    m: "пасовисько, оселя",
    d: "Місце пасовища, луг; житло, оселя.",
    u: "Використовується 13 разів у СЗ. На зелених пасовищах.",
    e: "Від נָאָה (наа) = бути гарним, відповідним"
  },
  "H5148": {
    m: "вести, направляти",
    d: "Вести, направляти, керувати; вести в безпеку.",
    u: "Використовується 40 разів у СЗ. Він веде мене (Пс 23:3).",
    e: "Первинний корінь"
  },
  "H5216": {
    m: "пасовисько, оброблена земля",
    d: "Луг, пасовисько; оброблена земля, поле.",
    u: "Використовується 2 рази в СЗ. Зелені пасовища.",
    e: "Від נִיר (нір) = орати"
  },
  "H5315": {
    m: "душа, життя, особа",
    d: "Душа, життя, жива істота; особа, сам; бажання, апетит.",
    u: "Використовується 753 рази в СЗ. Моя душа, моє життя.",
    e: "Від נָפַשׁ (нафаш) = дихати"
  },
  "H5769": {
    m: "вічність, завжди",
    d: "Невизначений час, вічність; завжди, безкінечність.",
    u: "Використовується 439 разів у СЗ. Вічна любов Божа.",
    e: "Від עָלַם (алам) = ховати, бути прихованим"
  },
  "H6186": {
    m: "впорядковувати, розставляти",
    d: "Впорядковувати, розставляти; готувати стіл.",
    u: "Використовується 75 разів у СЗ. Ти приготуєш стіл (Пс 23:5).",
    e: "Первинний корінь"
  },
  "H6213": {
    m: "робити, здійснювати",
    d: "Робити, виготовляти, здійснювати; діяти, працювати.",
    u: "Використовується 2632 рази в СЗ. Дуже часте дієслово.",
    e: "Первинний корінь"
  },
  "H6664": {
    m: "справедливість, праведність",
    d: "Справедливість, праведність, рівність; вірність.",
    u: "Використовується 119 разів у СЗ. Стежки справедливості.",
    e: "Від צָדַק (цадак) = бути справедливим"
  },
  "H6754": {
    m: "образ, подоба",
    d: "Образ, подоба; форма, вигляд.",
    u: "Використовується 17 разів у СЗ. Людина створена за образом Божим.",
    e: "Від צָלַל (цалал) = затінювати, бути схожим"
  },
  "H6757": {
    m: "тінь смерті, глибока темрява",
    d: "Глибока темрява, смертельна тінь; тінь смерті.",
    u: "Використовується 18 разів у СЗ. Символізує крайню небезпеку.",
    e: "Від צֵל (цель) = тінь + מָוֶת (мавет) = смерть"
  },
  "H6887": {
    m: "бути в скруті, супротивник",
    d: "Бути стиснутим, у скруті; супротивник, ворог.",
    u: "Використовується 58 разів у СЗ. У присутності моїх ворогів.",
    e: "Первинний корінь"
  },
  "H7121": {
    m: "кликати, кричати, проголошувати",
    d: "Кликати, кричати; називати; проголошувати, скликати.",
    u: "Використовується 736 разів у СЗ. Кликати ім'я Господа.",
    e: "Первинний корінь"
  },
  "H7200": {
    m: "бачити, дивитися",
    d: "Бачити очима; сприймати, розуміти; забезпечувати.",
    u: "Використовується 1311 разів у СЗ. Бог побачив, що це добре.",
    e: "Первинний корінь"
  },
  "H7225": {
    m: "початок, первоплоди",
    d: "Початок, зачаток; найкраще, первоплоди.",
    u: "Використовується 51 раз у СЗ. 'На початку Бог створив...'",
    e: "Від רֹאשׁ (рош) = голова, початок"
  },
  "H7257": {
    m: "лягати, відпочивати",
    d: "Лягати, відпочивати; перебувати; висиджувати.",
    u: "Використовується 30 разів у СЗ. Він дає мені спочити (Пс 23:2).",
    e: "Первинний корінь"
  },
  "H7291": {
    m: "переслідувати, ганяти",
    d: "Переслідувати, ганяти; гнобити; слідувати близько.",
    u: "Використовується 144 рази в СЗ. Доброта переслідуватиме мене.",
    e: "Первинний корінь"
  },
  "H7307": {
    m: "дух, подих, вітер",
    d: "Подих, вітер; дух Бога чи людини; духовне налаштування.",
    u: "Використовується 378 разів у СЗ. Дух Божий.",
    e: "Від רוּחַ (руах) = дути"
  },
  "H7462": {
    m: "пасти, пастир, годувати",
    d: "Пасти стадо; бути пастирем; годувати, доглядати.",
    u: "Використовується 173 рази в СЗ. Господь мій пастир.",
    e: "Первинний корінь"
  },
  "H7549": {
    m: "простір, твердь",
    d: "Простір, небесний звід, твердь; небо.",
    u: "Використовується 17 разів у СЗ. Простір посеред вод.",
    e: "Від רָקַע (рака) = простягати, бити"
  },
  "H7626": {
    m: "посох, плем'я",
    d: "Посох, жезл; плем'я, сімейна гілка.",
    u: "Використовується 190 разів у СЗ. Твій посох і твоя палиця.",
    e: "Від שָׁבַט (шабат) = галузитися"
  },
  "H7725": {
    m: "повертатися, відновлювати",
    d: "Повертатися, повернутися; відновлювати, оновлювати; каятися.",
    u: "Використовується 1058 разів у СЗ. Відновити мою душу.",
    e: "Первинний корінь"
  },
  "H7979": {
    m: "стіл",
    d: "Стіл для їди; стіл хлібів присутності.",
    u: "Використовується 71 раз у СЗ. Приготований стіл.",
    e: "Від שָׁלַח (шалах) = посилати, простягати"
  },
  "H8064": {
    m: "небеса, небо",
    d: "Небеса, твердь; оселя Бога; видиме небо.",
    u: "Використовується 420 разів у СЗ. Небеса і земля.",
    e: "Двоїна від שָׁמַיִם (шамайім) = висоти"
  },
  "H8414": {
    m: "безформний, порожній, хаос",
    d: "Пустеля, запустіння; хаос, порожнеча, ніщо.",
    u: "Використовується 20 разів у СЗ. Земля була безформна і порожня.",
    e: "Від תָּהָה (тага) = блукати"
  }
};

export default strongTranslationsUK;
